import React from "react";
import { Row, Container } from "reactstrap";
import AllEvents from "./AllEvents";
import PropTypes from "prop-types";

const All = ({ t, search, isSwitchOn, showArchives, userRole, userId, userEmail, token }) => {
  return (
    <React.Fragment>
      <Container fluid className="px-0">
        <div>
          <Row className="g-3 g-md-4">
            <AllEvents
              search={search}
              userId={userId}
              userEmail={userEmail}
              token={token}
              t={t}
              isSwitchOn={isSwitchOn}
              showArchives={showArchives}
              userRole={userRole}
            />
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};

All.propTypes = {
  t: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  isSwitchOn: PropTypes.bool.isRequired,
  showArchives: PropTypes.bool.isRequired,
  userRole: PropTypes.string,
  userId: PropTypes.string,
  userEmail: PropTypes.string,
  token: PropTypes.string,
};

export default All;